<generic-search-results
        [showHeader]="false"
        [showCounter]="false"
        [title]="''"
        [records]="requestData.groups"
        [displayedColumns]="displayColumns"
        [selectableRecords]="false"
        [allowLocalFilter]="false"
    ></generic-search-results>